import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  SimpleGrid,
  Button,
  Icon,
  useColorModeValue,
  Grid,
  Card, // Import Card
  CardBody, // Import CardBody
  // CardHeader, // Not strictly needed for this layout
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { ArrowRight } from '@phosphor-icons/react';

export const TechnologySection = () => {
  // Use theme tokens directly
  const sectionBg = useColorModeValue('bg.surface', 'bg.surface');
  const headingColor = useColorModeValue('interactive.primary', 'interactive.primary');
  const textColor = useColorModeValue('text.default', 'text.default');
  const textColorMuted = useColorModeValue('text.muted', 'text.muted');

  const technologies = [
    { name: "React", description: "Frontend framework for building our user interface" },
    { name: "Firebase", description: "Backend services for data storage and authentication" },
    { name: "Google Maps API", description: "Mapping services for location-based features" },
    { name: "TensorFlow.js", description: "Machine learning for feature detection" }
  ];

  return (
    <Box
      bg={sectionBg}
      py={{ base: 12, md: 16 }}
      position="relative" // Needed for pseudo-element
      _before={{ // Add background texture overlay
        content: '""',
        position: 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        opacity: useColorModeValue(0.08, 0.12), // Slightly more visible on surface bg
        pointerEvents: 'none',
        bgImage: useColorModeValue('var(--texture-parchment)', 'var(--texture-leather)'),
        bgRepeat: 'repeat',
        bgSize: '500px',
        bgBlendMode: useColorModeValue('soft-light', 'multiply'),
        zIndex: 0,
      }}
    >
      <Container maxW="container.xl" position="relative" zIndex={1}> {/* Content needs higher z-index */}
        {/* Removed outer Grid */}
          <VStack
            spacing={6} // Use theme spacing
            // Align items based on screen size, center on base, start on lg
            align={{ base: "center", lg: "flex-start" }}
            textAlign={{ base: "center", lg: "left" }}
            order={{ base: 2, lg: 1 }} // Keep text on left on large screens
          >
            <Heading as="h2" size="2xl" color={headingColor} fontFamily="heading">
              Technologies Used
            </Heading>
            <Text fontSize="lg" fontFamily="body" color={textColor}>
              Our platform leverages cutting-edge technologies to provide a seamless and powerful experience for megalithic research.
            </Text>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} width="full" pt={4}>
              {technologies.map((tech, index) => (
                <Card
                  key={index}
                  variant="journal"
                  position="relative" // Needed for pseudo-element
                  overflow="hidden" // Keep texture contained
                  _before={{ // Add internal texture
                    content: '""',
                    position: 'absolute',
                    top: 0, left: 0, right: 0, bottom: 0,
                    opacity: useColorModeValue(0.06, 0.1),
                    pointerEvents: 'none',
                    bgImage: 'var(--texture-aged)',
                    bgRepeat: 'repeat',
                    bgSize: '300px',
                    bgBlendMode: useColorModeValue('multiply', 'soft-light'),
                    zIndex: 0,
                    borderRadius: 'inherit',
                  }}
                >
                  <CardBody position="relative" zIndex={1}> {/* Use CardBody for padding & ensure content is above texture */}
                    <VStack align="flex-start" spacing={1}>
                      <Heading size="md" fontFamily="heading" color={textColor}>
                        {tech.name}
                      </Heading>
                      <Text fontSize="sm" color={textColorMuted} fontFamily="body">
                        {tech.description}
                      </Text>
                    </VStack>
                  </CardBody>
                </Card>
              ))}
            </SimpleGrid>

            <Button
              as={Link}
              to="/search" // Link to search page as per original code
              size="lg"
              variant="journal" // Apply themed variant
              rightIcon={<Icon as={ArrowRight} weight="bold" />}
              mt={4} // Add margin top
            >
              Explore Our Sites
            </Button>
          </VStack>
          {/* Removed placeholder Box and the surrounding Grid */}
      </Container>
    </Box>
  );
};